import { render, staticRenderFns } from "./taskstage.vue?vue&type=template&id=1ab3932e&scoped=true"
import script from "./taskstage.vue?vue&type=script&lang=js"
export * from "./taskstage.vue?vue&type=script&lang=js"
import style0 from "./taskstage.vue?vue&type=style&index=0&id=1ab3932e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab3932e",
  null
  
)

export default component.exports